import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const DropdownList = ({
  itemList = [],
  handleSubmit = () => {},
  showPopularTitle = false,
  setSubmitId = () => {},
  submitId = 0
}) => {
  const listItemRefs = useRef([]);
  const { t } = useTranslation();

  useEffect(() => {
    if (submitId == null) {
      setSubmitId(0);
    } else if (submitId !== 0 && listItemRefs?.current[submitId]) {
      listItemRefs?.current[submitId]?.focus();
    }
  }, [submitId]);

  useEffect(() => {
    document.addEventListener('keydown', handleKeydownEvent);

    return () => {
      document.removeEventListener('keydown', handleKeydownEvent);
    };
  });

  const handleKeydownEvent = (event = { preventDefault() {} }) => {
    if (event.key === 'ArrowUp') {
      const prevId = submitId === 0 ? itemList.length - 1 : submitId - 1;
      setSubmitId(prevId);
    }

    if (event.key === 'ArrowDown') {
      const nextId = submitId === itemList.length - 1 ? 0 : submitId + 1;
      setSubmitId(nextId);
    }

    if (event.key === 'Enter') {
      event.preventDefault();
      handleSubmit(submitId, 'Enter', 'Typed Search');
    }
  };

  const renderList = () => {
    return itemList?.map((item, id) => {
      return (
        <li
          id={`option-${id}`}
          className={`listItem ${submitId === id ? 'active' : ''}`}
          key={id}
          onClick={() => handleSubmit(id, '', 'Popular Now')}
          ref={listitem => (listItemRefs.current[id] = listitem)}
          aria-label={item.displayName}
          role="option"
          aria-selected={submitId === id}
        >
          {item.displayName}
        </li>
      );
    });
  };

  return (
    <article className="listContainer">
      {showPopularTitle && (
        <>
          <span className="title">{t('POPULAR NOW')}</span>
          <span className="title newTitle d-none">{t('Popular Now')}</span>
        </>
      )}
      <ul id="site-search-results" className="list" role="listbox">
        {renderList()}
      </ul>
    </article>
  );
};

DropdownList.propTypes = {
  itemList: PropTypes.array,
  handleSubmit: PropTypes.func,
  showPopularTitle: PropTypes.bool,
  setSubmitId: PropTypes.func,
  submitId: PropTypes.number
};

export default DropdownList;
